import React from 'react';
import { observer } from 'mobx-react';
import VirtualizedTable from '../common/VirtualizedTable';

export default observer(props => {
  const columns = [
    { key: 'description', label: 'Operation', width: 300 },
    { key: 'setupTimeAsString', label: 'Setup', width: 150 },
    { key: 'operationTimeAsString', label: 'Operation', width: 150 },
  ]
  return <VirtualizedTable 
    columns={columns}
    {...props}
  />
})


// WEBPACK FOOTER //
// ./src/components/standard-operations/StandardOperationTable.js